export default "__VITE_ASSET__zm6Tgarr__"